import React from 'react';
import { Col, Container, FormGroup, Label, Row } from 'reactstrap';
import { Field, Fields } from 'redux-form';
import { compact } from 'underscore';

// components
import BufferedInput from '../../../components/form/field/buffered-input';
import PriceFilter from '../../../components/form/filter/price-filter';
import YearFilter from '../../../components/form/filter/year-filter';
import { LocationTypeAheadField } from '../../../components/form/field/location-typeahead';
import WaterfrontTypeFilter from '../../../components/form/filter/waterfront-type-filter';
import BuildingTypeFilter from '../../../components/form/filter/building-type-filter';
import PreferenceFilter from '../../../components/form/filter/preference-filter';
import StatusFilter from '../../../components/form/filter/status-filter';
import CityFilter from '../../../components/form/filter/city-filter';

// modules
import BS from '../../../theme/Bootstrap';
import formStyles from '../../../components/form/form.module.scss';
import styles from '../../Containers.module.scss';

const ResidentialAdvancedSearch = props => {
  return (
    <Container className={`${BS.alignItemsStart}`}>
      <Row>
        <Col xs={12} md={4}>
          <FormGroup>
            <Label className={styles.label} for="address">
              Location:
            </Label>
            <LocationTypeAheadField name="address" propertyClass="residential_income" />
          </FormGroup>
          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minPrice">
              Price:
            </Label>
            <Fields
              names={['minPrice', 'maxPrice']}
              component={PriceFilter}
              showSelects
              type="residential_income"
            />
          </FormGroup>
          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minGrossIncome">
              Gross Rental Income:
            </Label>
            <Fields
              names={['minGrossIncome', 'maxGrossIncome']}
              component={PriceFilter}
              type="residential_income"
            />
          </FormGroup>

          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minYear">
              Year Built:
            </Label>
            <Fields names={['minYear', 'maxYear']} component={YearFilter} />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Label className={styles.label} for="location">
          City:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="city"
            component={CityFilter}
          />
        </div>
      </FormGroup>
      <FormGroup row>
        <Col xs={12} md={4}>
          <Label className={styles.label} for="location">
            MLS ID:
          </Label>
          <div>
            <Field
              name="mlsNumber"
              type="text"
              placeholder="MLS ID"
              component={BufferedInput}
            />
          </div>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col xs={12} md={4}>
          <Label className={styles.label} for="status">
            Status:
          </Label>
          <Field name="status" component={StatusFilter} type="residential_income" />
        </Col>
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="buildingType">
          Building Type:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="buildingType"
            type="residential_income"
            component={BuildingTypeFilter}
          />
        </div>
      </FormGroup>

      <Row>
        <Col xs={12} md={4}>
          <FormGroup>
            <Label className={styles.label} for="waterfrontYN">
              Waterfront:
            </Label>
            <Field name="waterfrontYN" component={PreferenceFilter} />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Label className={styles.label} for="waterfront">
          Waterfront Description:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="waterfront"
            component={WaterfrontTypeFilter}
          />
        </div>
      </FormGroup>
    </Container>
  );
};

export default ResidentialAdvancedSearch;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/AdvancedSearch/ResidentialIncomeAdvancedSearch.js